import { EventTriggerFixed } from '@user-portal/wikr-analytics';

import { trackEventFixed } from './mainTrackers';

export const sendAnalyticCabinetStartSession = () => {
  trackEventFixed({ event: EventTriggerFixed.cabinetSessionStarted });
};
